import {useEffect, useRef, useState} from 'react';


// Loads libraries dynamically. The importmap should contain the definitions.
// Params
//   import_promises - array of import promises
//   sideEffects - if library loads side effects (globals), provide expected variable to check against
// Returns
//   Resolved modules in the order of libs
export default function useDynamicLibs(import_promises, sideEffects = []) {
  const initialState = sideEffects.length > 0 && sideEffects.every(e => window[e] !== undefined)
  const [libLoaded, setLibLoaded] = useState(initialState)
  const modules = useRef(null);

  useEffect(() => {
    if (!libLoaded) {

      Promise.all(import_promises).then((mods) => {
        modules.current = mods;
        console.debug("Succesfully loaded modules", import_promises)
        setLibLoaded(true);
      }).catch((err) => {
        console.error('Error loading modules:', import_promises, errs);
      });      
    }
  }, [])

  return [libLoaded, modules.current]
}